import server from "../../../../server";
import { Document_Type } from "../../../../constant/constant";
import { RcFile } from "antd/lib/upload";

export async function uploadDocument(file: RcFile[],
                                     docType: keyof typeof Document_Type,
                                     docNumber?: string,
                                     employeeId?: string,
                                     metaData?: any,
                                     documentPurpose?: string) {

    const res = await server.document.upload(file, docType, docNumber, employeeId, metaData, documentPurpose)
    return res;
}

export async function getMetData(type: string) {
    const res = await server.document.fetchMetaData(type);
    return res;
}





